/**
 * TanStack Router: /calendar
 *
 * This route file was auto-generated by the route generation script.
 * Component: CalendarPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import CalendarPage from '@/app/calendar/page'

/**
 * Route: /calendar
 * Layout: _auth (authenticated)
 * Component: CalendarPage
 */
export const Route = createFileRoute('/_auth/calendar')({
  component: CalendarPage,
})
